<template>
  <div>
    <div id="login_container"></div>
    <common-dialog
      title="绑定手机号"
      :dialogVisible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogVisible = false"
    >
      <div class="dialog-body-wrap">
        <div class="input-wrap">
          <label>手机号：</label>
          <el-input
            v-model="mobile"
            placeholder="请输入手机号"
            class="input"
          ></el-input>
        </div>
        <div class="input-wrap">
          <label>验证码：</label>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            class="input"
          ></el-input>
          <div
            v-if="isGettingCode"
            class="text"
          >{{countDown}}s</div>
          <el-button
            type="primary"
            v-if="!isGettingCode"
            @click="onGetcodeClick"
            class="btn"
          >获取验证码</el-button>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { wxLogin, wxBindMobile, sendCode, menulist } from "@/api/common";
import CommonDialog from "@/components/CommonDialog";
import { mapMutations, mapActions } from "vuex";
import Utils from "@/jslibs/utils";
import { pms2MenuList } from "../filters/filter";

export default {
  data() {
    return {
      dialogVisible: false,
      open_id: "",
      code: "",
      mobile: "",
      countDown: 60,
      isGettingCode: false
    };
  },
  components: {
    CommonDialog
  },
  mounted() {
    console.log("wxlogin");
    var obj = new WxLogin({
      id: "login_container",
      appid: "wx8bf5b01ee8a36880",
      scope: "snsapi_login",
      redirect_uri: encodeURIComponent("https://file-admin.gymooit.cn"),
      state: ""
    });
    const code = this.$route.query.code;
    if (code) {
      this._wxLogin(code);
    }
  },
  computed: {},
  methods: {
    ...mapMutations([
      "update_operation_list",
      "update_permission_list",
      "updateLoginData"
    ]),
    ...mapActions(["getAllFileClass"]),
    async _wxLogin(code) {
      try {
        const {
          status,
          data: { result: resData }
        } = await wxLogin({ code });
        if (status === 200) {
          Utils.setCookie("X-Access-Token", resData.token, 3); // TODO: 先设三天过期
          this.updateLoginData(resData);
          this.handleMenu(resData.group.rule);
          console.log(resData, "已绑定登录成功");
        }
      } catch (e) {
        if (e.error) {
          const { open_id } = e.error;
          this.dialogVisible = true;
          this.open_id = open_id;
        }
        console.log(e, "error login");
      }
    },
    async dialogConfirmClick() {
      if (!this.validate()) {
        return;
      }
      if (!this.code) {
        this.$message("请输入验证码");
        return;
      }
      const postData = {
        open_id: this.open_id,
        mobile: this.mobile,
        code: this.code
      };
      const {
        status,
        data: { result: resData }
      } = await wxBindMobile(postData);
      if (status === 200) {
        Utils.setCookie("X-Access-Token", resData.token, 3); // TODO: 先设三天过期
        this.updateLoginData(resData);
        this.handleMenu(resData.group.rule);
        console.log(resData, "绑定手机成功");
      }
    },
    validate() {
      if (!this.mobile) {
        this.$message("请输入手机号");
        return;
      }
      const reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
      if (!reg.test(this.mobile)) {
        this.$message("请输入正确手机号");
        return;
      }
      return true;
    },
    onGetcodeClick() {
      if (!this.validate()) {
        return;
      }
      sendCode({ mobile: this.mobile, type: "1" });
      this.isGettingCode = true;
      let timer = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(timer);
          this.isGettingCode = false;
          this.countDown = 60;
          return;
        }
        this.countDown--;
      }, 1000);
    },
    handleMenu(rule) {
      const permissionList = [];
      const operationList = [];
      rule.forEach(one => {
        const children = [];
        one.son_rule.forEach(two => {
          children.push({
            name: two.menu_name,
            menu_url: two.menu_url
          });
          //把三级权限数据赋给oprationlist
          //在二级页面根据oprationlist 匹配三级权限
          let three = [];
          if (two.son_rule && two.son_rule.length) {
            //如果菜单有二级
            three = two.son_rule.map(item => {
              return item.menu_name;
            });
          }
          operationList.push({
            name: two.menu_name,
            operations: three
          });
        });
        permissionList.push({
          name: one.menu_name,
          children
        });
      });
      let menuList = pms2MenuList(permissionList);
      this.update_operation_list(operationList);
      this.update_permission_list(menuList);
      this.getAllFileClass();
      if (menuList[0].children && menuList[0].children.length) {
        this.$router.push(menuList[0].children[0].route);
      } else {
        this.$router.push(this.menuList[0].route);
      }
      console.log(menuList, operationList, "处理后菜单");
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

#login_container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    width: 80px;
    text-align: right;
    margin-right: 20px;
  }
  .input {
    flex: 1;
  }
  .text {
    width: 80px;
    padding: 10px;
    background: #e5e5e5;
    color: @main-color;
    margin-left: 20px;
  }
  .btn {
    margin-left: 20px;
  }
}
</style>